import classNames from "classnames/bind";
import styles from "./AddObject.module.css";
import { Button, Empty, HeaderModal, InputTextBox, Loading, SelectBox, SelectBoxItem, Toast } from "../../../../components";
import Dragger from "antd/es/upload/Dragger";
import DragUploadImage from "../../../../components/DragUploadImage";
import { useEffect, useRef, useState } from "react";
import { departmentFSR } from "../../../../services/api/departmentFSR";
import { ConfigProvider, Select } from "antd";
import { DownIcons } from "../../../../components/Icons/Icons";
import { listObjectFSR } from "../../../../services/api/listObjectFSR";
import { companyFSR } from "../../../../services/api/companyFSR";
import { checkRoleSupAdmin } from "../../../../utils";
const cx = classNames.bind(styles);

const AddObject = ({ onClose, id, info, onReFresh }) => {
    const [infoEmployee, setInfoEmployee] = useState({
        name: '',
        department: null,
        listImage: [],
        company: !checkRoleSupAdmin() ? sessionStorage?.getItem("company_code") : null,
        companyName: "",
        departmentName: "",
    })
    const [listDepartment, setListDepartment] = useState([])
    const [listCompanies, setListCompaies] = useState([])
    const refModal = useRef(null)
    const handleChangeFile = (value) => {
        setInfoEmployee(prev => ({ ...prev, listImage: value }))
    }
    const [loading, setLoading] = useState(false)
    const [listIdImageRemove, setListIdImageRemove] = useState([])
    const getListDepartment = async (company) => {
        try {
            const param = {
                page: 1,
                limit: 1000,
                organization_code: company
            }
            const res = await departmentFSR.get(param)
            if (res && res?.data) {
                const departments = res?.data?.map(item => {
                    return {
                        value: item?.id,
                        label: item?.name
                    }
                })
                setListDepartment(departments)
            }
        } catch (error) {
            throw error;
        }
    }
    const getListCompanies = async () => {
        try {
            const res = await companyFSR.get()
            if (res) {
                const departments = res?.map((item, index) => {
                    if (index === 0 && !id) {
                        setInfoEmployee(pre => ({ ...pre, company: item?.CODE, companyName: item?.NAME }))
                    }
                    return {
                        value: item?.CODE,
                        label: item?.NAME
                    }
                })
                setListCompaies(departments)
            }
        } catch (error) {
            throw error;
        }
    }
    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                onClose();
            }
        };
        document.addEventListener("click", handleCloseOnClickOutSide);
        return () => {
            document.removeEventListener("click", handleCloseOnClickOutSide);
        };
        // eslint-disable-next-line
    }, []);

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const validateInfo = (listDpCode, name, image) => {
        if (listDpCode && name && name?.trim().length > 0 && image?.length > 0) {
            return true
        } else {
            return false
        }
    }


    const handleAccept = async () => {
        const checkValidate = validateInfo(infoEmployee?.department, infoEmployee?.name, infoEmployee?.listImage)
        if (checkValidate) {
            try {
                setLoading(true)
                const formInfoData = new FormData();
                // const departmentAdded = getAddDepartment(infoEmployee?.department);
                const blobDp = new Blob([infoEmployee?.department], { type: "application/json" })
                const blobName = new Blob([infoEmployee?.name], { type: "application/json" })
                formInfoData.append('id_department', blobDp);
                formInfoData.append('name', blobName);
                infoEmployee?.listImage?.forEach((item) => {
                    formInfoData.append('files', item?.originFileObj)
                })
                await listObjectFSR.add(formInfoData)
                setLoading(false)
                Toast.open('Thêm mới đối tượng thành công', 'success')
                onClose()
                onReFresh()
            } catch (error) {
                // console.log(error);
                setLoading(false)
                if (error?.response?.data?.message) {
                    Toast.open(`${error?.response?.data?.message}`, "danger")
                } else {
                    Toast.open('Thêm mới đối tượng không thành công', 'danger')
                }
            }
        } else {
            Toast.open("Phòng ban, tên nhân viên và ảnh không được để trống", 'danger')
        }

    }

    const getInfoObject = async (id) => {
        try {
            const res = await listObjectFSR.getById(id)
            const info = { ...res?.data };
            const listImage = info?.images?.map(item => {
                return {
                    id_image: item?.id,
                    thumbUrl: `${process.env.REACT_APP_FSR_IP}${item?.path || null}`
                }
            })
            setInfoEmployee({
                name: info?.staffName || '',
                department: info?.departmentCode || "",
                listImage: listImage,
                company: info?.organizationCode || "",
                companyName: info?.organizationName || "",
            })
        } catch (error) {
            Toast.open("Lấy thông tin của đối tượng không thành công", "dnager")
            onClose()
        }
    }

    useEffect(() => {
        const getInfoDefault = async () => {
            setLoading(true)
            try {
                if (id) {
                    await getInfoObject(id)
                }
                if (checkRoleSupAdmin()) {
                    await getListCompanies()
                }
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }
        getInfoDefault()
    }, [id])
    useEffect(() => {
        if (infoEmployee?.company) {
            getListDepartment(infoEmployee?.company)
        }
    }, [infoEmployee?.company])

    const handleRemoveImg = (val) => {
        setListIdImageRemove(prev => [...prev, val])
    }


    const handleAcceptEdit = async () => {
        const checkValidate = validateInfo(infoEmployee?.department, infoEmployee?.name, infoEmployee?.listImage)
        if (checkValidate) {
            try {
                setLoading(true)
                const formInfoData = new FormData();
                // const departmentAdded = getAddDepartment(infoEmployee?.department);
                const blobDp = new Blob([infoEmployee?.department], { type: "application/json" })
                const blobName = new Blob([infoEmployee?.name], { type: "application/json" })
                const listImgRemoved = listIdImageRemove?.map(item => item?.id_image)
                let params = '?'
                listImgRemoved?.forEach((item, index) => {
                    params += `idImagesRemove=${item}${index < listIdImageRemove?.length - 1 ? '&' : ''}`
                })
                formInfoData.append('idDepartment', blobDp);
                formInfoData.append('staffName', blobName);
                infoEmployee?.listImage?.forEach((item) => {
                    if (!item?.id_image) {
                        formInfoData.append('file', item?.originFileObj)
                    }
                })
                await listObjectFSR.edit(id, params, formInfoData)
                setLoading(false)
                Toast.open('Sửa đối tượng thành công', 'success')
                onClose()
                onReFresh()
            } catch (error) {
                // console.log(error);
                setLoading(false)
                if (error?.response?.data?.message) {
                    Toast.open(`${error?.response?.data?.message}`, "danger")
                } else {
                    Toast.open('Sửa đối tượng không thành công', 'danger')
                }
            }
        } else {
            Toast.open("Phòng ban, tên nhân viên và ảnh không được để trống", 'danger')
        }
    }
    return (
        <div className={cx('wrraper-modal')} ref={refModal}>
            <div className={cx('content')}>
                <HeaderModal onClose={onClose} title={`${id ? 'Sửa thông tin' : 'Thêm mới'}` + ' đối tượng'} />
                <div className={cx('form-info-object')}>
                    <InputTextBox
                        title={'Tên nhân viên *'}
                        style={{ flex: 1, marginTop: 2 }}
                        placeholder={"Tên nhân viên"}
                        value={infoEmployee?.name}
                        onChange={(val) => setInfoEmployee(prev => ({ ...prev, name: val }))}
                    />
                    <label className={cx('select-wrap')}>
                        <p className={cx('label')}>Đơn vị *</p>
                        <Select
                            options={listCompanies || []}
                            className={cx('select')}
                            placeholder={"Tất cả"}
                            notFoundContent={<></>}
                            suffixIcon={<DownIcons />}
                            maxTagCount={'responsive'}
                            filterOption={filterOption}
                            onChange={(val) => setInfoEmployee(prev => ({ ...prev, company: val, companyName: val, department: null }))}
                            defaultValue={!id ? infoEmployee?.company : infoEmployee.companyName}
                            value={!id ? infoEmployee?.company : infoEmployee.companyName}
                            disabled={!localStorage?.getItem("role")?.split(",").some(r => r === "A") || !!id}
                        >
                        </Select>
                    </label>
                    <label className={cx('select-wrap')}>
                        <p className={cx('label')}>Phòng ban *</p>
                        <Select
                            // mode="multiple"
                            options={listDepartment}
                            className={cx('select')}
                            placeholder={"Tất cả"}
                            notFoundContent={<></>}
                            suffixIcon={<DownIcons />}
                            maxTagCount={'responsive'}
                            filterOption={filterOption}
                            onChange={(val) => setInfoEmployee(prev => ({ ...prev, department: val }))}
                            defaultValue={infoEmployee?.department}
                            value={infoEmployee?.department}
                        />
                    </label>
                </div>
                <div className={cx('image')}>
                    <DragUploadImage onChange={handleChangeFile} fileList={infoEmployee?.listImage} onDelete={(val) => handleRemoveImg(val)} />
                </div>
                <div className={cx('foolter')}>
                    {/* <Button title={'Hủy bỏ'} className={cx('cancel')} onClick={onClose} /> */}
                    <Button title={'Xác nhận'} className={cx('accept')} onClick={() => id ? handleAcceptEdit() : handleAccept()} />
                </div>
            </div>
            {loading && <div className={cx('modal-loading')}>
                <Loading />
            </div>}
        </div>
    )
}

export default AddObject;
